import React from "react";
import { useNavigate } from "react-router-dom";

const hasBrowserHistory = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const historyIndex = window.history?.state?.idx;

  if (typeof historyIndex === "number") {
    return historyIndex > 0;
  }

  return window.history.length > 1;
};

const HelpBackButton = ({
  fallbackTo = "/",
  homeTo = "/",
  className = "",
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (hasBrowserHistory()) {
      navigate(-1);
      return;
    }

    navigate(fallbackTo);
  };

  const handleHome = () => {
    navigate(homeTo);
  };

  return (
    <div className={`help-center-nav-actions ${className}`.trim()}>
      <button
        type="button"
        className="help-back-button"
        onClick={handleBack}
        aria-label="Go back to the previous page"
      >
        <span aria-hidden="true" className="help-back-button-icon">
          ←
        </span>
        <span>Back</span>
      </button>
      <button
        type="button"
        className="help-back-button help-home-button"
        onClick={handleHome}
        aria-label="Go to the site home page"
      >
        <span aria-hidden="true" className="help-back-button-icon">
          ⌂
        </span>
        <span>Home</span>
      </button>
    </div>
  );
};

export default HelpBackButton;
